<template>
  <b-card no-body v-if="active">
    <b-card-header header-tag="header" class="p-1" role="tab" v-b-toggle="'sms-notifications-unavailable-banner-collapse'">
      Important Notice: SMS Notifications Restored 📱 <small>(Click for more details)</small>
    </b-card-header>
    <b-collapse id="sms-notifications-unavailable-banner-collapse" accordion="my-accordion" role="tabpanel">
      <b-card-body class="description">
        <p>
          SMS notification services have been restored.
        </p>
        <p>
          We apologize for any inconvenience and appreciate your understanding.
        </p>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      // Display until the end of 10/27/2023. Be a good steward, kill this comment if you're in here.
      active: moment() < moment('2023-10-28T00:00:00Z'),
    }
  }
}
</script>

<style lang="scss" scoped>
div.card {
  @include border-radius($border-radius);
  @include pop-green-gradient;

  color: $black;
  padding-left: 5px;
  font-weight: bold;
  font-size: 18px;
  margin-bottom:15px;
  
  .card-header {
    cursor: pointer;
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    background-color: rgba(0, 0, 0, 0.00);
    border-bottom: none
  }
}
</style>